import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient, {
  ApproveCollectionParams,
} from "../../../api/collection";
import refetchCollectionQueries from "../utils/refetchCollectionQueries";

const useApproveCollectionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["approve-collection"],
    mutationFn: ({
      collectionId,
      message,
      planId,
      marketplaceStatus,
    }: ApproveCollectionParams) =>
      collectionApiClient.approveCollection({
        collectionId,
        message,
        planId,
        marketplaceStatus,
      }),

    onSettled: () => refetchCollectionQueries(queryClient),
  });
};

export default useApproveCollectionMutation;
